import { useEffect, useState, useCallback } from "react";
import { Row, Col, Form, Card } from "react-bootstrap";
import { VscReplace } from "react-icons/vsc";
import { BiEdit } from "react-icons/bi";
import HtmlEditor from "../../../components/UI/HtmlEditorInput/HtmlEditor";
import ListaImpedimentos from "./components/ListaImpedimentos";
import SelectFileInput from "../../../components/UI/SelectFileInput/SelectFileInput";
import ConsultaAnexos from "../Anexos/ConsultaAnexos";
import FormAlert from "../../../components/UI/FormAlert/FormAlert";
import ListaExecutores from "../ListaExecutores";
import FormAtividades from "./components/FormAtividades";
import FormAtividadeIF1 from "./components/FormAtividadeIF1";
import FormAtividadesAR from "./components/FormAtividadesAR";
import CheckListDocumentosPAT from "./components/ChecklistPAT/CheckListDocumentosPAT";
import useVisualizarDocumento from "./hooks/useVisualizarDocumento";

const TelaComunicado = ({ formik, dadosOs, atividade }) => {
  const [showTextoAtividade, setShowTextoAtividade] = useState(
    atividade.siglaAtividade === "IF1" ||
      atividade.siglaAtividade === "I1" ||
      atividade.siglaAtividade === "D0" ||
      atividade.siglaAtividade === "AUGEIMTENC"
      ? false
      : true,
  );
  const [showListaExecutores, setShowListaExecutores] = useState(false);
  const [livrosDescricao, setlivrosDescricao] = useState([]);

  const trocarTextoFormik = () => {
    formik.setValues((curr) => ({
      ...curr,
      textoImpedimento: formik.values.textoImpedimento
        ? formik.values.textoImpedimento.replace("[NUMOS]", dadosOs.sequencial)
        : "",
    }));
  };

  useEffect(() => {
    if (dadosOs?.listaLivrosDescricao === null || dadosOs?.listaLivrosDescricao === undefined) {
      setlivrosDescricao([]);
    } else {
      setlivrosDescricao([dadosOs.listaLivrosDescricao.split(",")]);
    }
  }, [dadosOs]);

  useEffect(() => {
    if (atividade.siglaAtividade === "DISUBAUDOS") setShowListaExecutores(true);
  }, [setShowListaExecutores, atividade.siglaAtividade]);

  const { handleImprimirDocumento, isLoadingDocumento, dataDownload, errorDownload } = useVisualizarDocumento({ dadosOs });

  const handleExibirDocumento = useCallback(() => {
    handleImprimirDocumento();
  }, [handleImprimirDocumento]);

  return (
    <>
      <FormAlert
        formik={formik}
        data={dataDownload}
        errors={errorDownload}
        isLoading={isLoadingDocumento}
        dismissible
      />
      {atividade.siglaAtividade === "INAUDALIMP" && (
        <Row>
          <Form.Group as={Col} sm={12} md={12}>
            <ListaImpedimentos formik={formik} field="impedimentos" ativar />
          </Form.Group>
        </Row>
      )}
      {/* Componente com campos específicos de cada atividade */}
      <Row>
        <Form.Group as={Col} sm={12} md={12}>
          <FormAtividades
            formik={formik}
            acaoFiscal={dadosOs.acaoFiscal}
            siglaAtividade={atividade.siglaAtividade}
            atividade={atividade}
          />
        </Form.Group>
      </Row>
      {(atividade.siglaAtividade === "IF2" ||
        atividade.siglaAtividade === "IF3" ||
        atividade.siglaAtividade === "AUINFAALDO" ||
        atividade.siglaAtividade === "AUIMPRREDO" ||
        atividade.siglaAtividade === "AUGEIMDODE") && (
        <Row>
          <Form.Group as={Col} sm={12} md={12}>
            {atividade.siglaAtividade === "AUGEIMDODE" ? (
              <Form.Label>Documentos recebidos:</Form.Label>
            ) : (
              <Form.Label>Documentos solicitados:</Form.Label>
            )}
            {/* <Form.Label>Documentos solicitados:</Form.Label> <br /> */}
            <br />
          </Form.Group>
          <Col sm="4" lg="10">
            <Card.Text as="p">
              {livrosDescricao.length > 0 &&
                livrosDescricao[0].map((livroDescrito) => <li key={livroDescrito}>{livroDescrito}</li>)}
            </Card.Text>
          </Col>
        </Row>
      )}
      <br />
      {(atividade.siglaAtividade === "IF1" ||
        atividade.siglaAtividade === "IF2" ||
        atividade.siglaAtividade === "IF3" ||
        atividade.siglaAtividade === "AUIMPRREDO" ||
        atividade.siglaAtividade === "AUINFAALDO" ||
        atividade.siglaAtividade === "AUGEIMDODE") && (
        <Row>
          <Form.Group as={Col} sm={12} md={12}>
            {atividade.siglaAtividade === "AUGEIMDODE" && <Form.Label>Documentos devolvidos:</Form.Label>}
            {(atividade.siglaAtividade === "AUIMPRREDO" || atividade.siglaAtividade === "AUINFAALDO") && (
              <Form.Label>Documentos recebidos:</Form.Label>
            )}
            {(atividade.siglaAtividade === "IF1" ||
              atividade.siglaAtividade === "IF2" ||
              atividade.siglaAtividade === "IF3") && <Form.Label>Documentos a serem solicitados:</Form.Label>}
            <FormAtividadeIF1
              formik={formik}
              field="livrosFiscais"
              dataInicial={dadosOs.dataInicialFiscalizacao}
              dataFinal={dadosOs.dataFinalFiscalizacao}
              sqComunicado={dadosOs.sequencialComunicado}
              sqComunicadoIF1={dadosOs.sequencialComunicadoUltimaAtividadeIF1}
            />
          </Form.Group>
        </Row>
      )}
      {atividade.siglaAtividade === "AULATERARB" && (
        <Row>
          <Form.Group as={Col} sm={12} md={12}>
            <FormAtividadesAR formik={formik} />
          </Form.Group>
        </Row>
      )}
      {atividade.siglaAtividade === "PATANAPROC" && (
        <Row>
          <Form.Group as={Col} sm={12} md={12}>
            <CheckListDocumentosPAT acaoFiscal={dadosOs.acaoFiscal} numOs={dadosOs.sequencial} />
          </Form.Group>
        </Row>
      )}
      <Row className="mt-2">
        <Col>
          <hr />
          <Form.Label>
            <strong>Texto da Atividade</strong>
            <BiEdit
              className="btn-lg  text-danger pa-0 p-0 btn btn-bg-transparent ml-2"
              title={showTextoAtividade ? "Editar Texto" : "Fechar Edição"}
              onClick={() => {
                setShowTextoAtividade(!showTextoAtividade);
                trocarTextoFormik();
              }}
            />
            {dadosOs?.sequencialComunicado > 0 && (
              <VscReplace
                className="btn-lg  text-danger pa-0 p-0 btn btn-bg-transparent ml-2"
                title="Visualizar Documento"
                onClick={() => handleExibirDocumento(dadosOs)}
              />
            )}
          </Form.Label>
          {!showTextoAtividade && <HtmlEditor formik={formik} field="textoImpedimento" rows="5" />}
          <hr hidden={!showTextoAtividade} />
        </Col>
      </Row>
      <br />
      <Row>
        <Form.Group as={Col} sm={12} md={12}>
          <span hidden={!showListaExecutores}>
            <ListaExecutores formik={formik} field="listaExecutoresOs" dadosOs={dadosOs} origem="atividadeOs" />
          </span>
        </Form.Group>
      </Row>
      <br />
      <Row>
        {dadosOs.fgPermiteAnexo === "S" || atividade.fgPermiteAnexo === "S" ? (
          <Form.Group as={Col} sm={12} md={12}>
            <Form.Label>Anexos</Form.Label> <br />
            <SelectFileInput
              id="tab-anexos-arquivos"
              field="anexos"
              formik={formik}
              accept=".jpeg, .pdf, .xls, .xlsx, .doc, .docx"
              multiple
              save
              describe
            />
          </Form.Group>
        ) : null}
      </Row>
      <ConsultaAnexos
        sqAcaoFiscal={dadosOs.acaoFiscal}
        sqOrdemServico={dadosOs.sequencial}
        sqComunicado={dadosOs.sequencialComunicado}
        sqAtividade={dadosOs.sequencialAtividadeComunicado}
        permissao
      />
    </>
  );
};

export default TelaComunicado;
